<template>
    <customModal :containersm="true" :footerShow="true" @closeModal="$emit('close')">
        <template #title>
           {{ title }}
        </template>

        <template #body>
            <label class="col-form-label">Comments</label>
            <textarea class="form-control message-input" name="message" placeholder="Enter your comments here"
                v-model="localComments"></textarea>
        </template>

        <template #footer>
            <div class="text-center">
                <button type="button" class="btn btn-green-new btn-sm py-0 text-white mr-2" @click="QcReviewSubmit(true)">
                  {{ context == "approval" ? "Approve" : context == "qc" ? "QC Pass" : context == "review" ?"Review" : "Complete" }}
                </button>
                <button type="button" class="btn btn-danger-new btn-sm py-0 px-3 mr-2" @click="QcReviewSubmit(false)">
                    Reject
                </button>
            </div>
        </template>
    </customModal>
</template>
<style scoped>
.btn-green-new {
    color: #fff;
    background-color: #1ab394;
    /* border-color: #1ab394; */
    border: none;
}

.btn-danger-new {
    color: #fff;
    background-color: #ed5565;
    border: none;
}
</style>
<script src="./QcReviewPopup.js"></script>

